<template>
    <div>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getLogs"
                    :table-search="mainTable.tableSearch" />
                </Col>
                
            </Row>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">会员信息操作日志列表</span>
                    </div>
                    <div class="right-bar">
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="onExport">导出</Button>
                    </div>
                </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="mainTable.data"
                    :extHeight="60"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getLogs" />
                </Col>
            </Row>
        </Card>

        <ExternalCustomerUserEdit ref="externalCustomerUserModal" />
        <BlackUserListModal ref="blackUserListModal"/>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { getLogList } from '@/api/modules/system-management/log-management';
import { DOWNLOAD_SERVER } from '@/api/modules/files';
export default {
    name: 'CustomerUserLogList',
    components: {
        SearchCard,
        StandPaginationTable
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            mainTable: {
                columns: [
                    {
                        title: "时间",
                        key: "CreateTime",
                        align: 'center',
                        width: 150,
                        render: (h, params) =>
                            h(
                                "span",
                                params.row.CreateTime
                                    ? params.row.CreateTime
                                        .substr(0, 19)
                                        .replace("T", " ")
                                    : ""
                            )
                    },
                    { title: "客户编号", key: "customerUserName", width: 150, align: 'center' },
                    { title: "客户姓名", key: "customerPersonName", width: 150, align: 'center' },
                    { title: "客户电话", key: "customerPhone", width: 150, align: 'center' },
                    {   
                        title: "类型", 
                        key: "OperationType", 
                        align: 'center',
                        width: 80,
                        render: (h, params) =>
                            h(
                                "span",
                                params.row.OperationType==1
                                    ? "新增":params.row.OperationType==2?"删除"
                                        : params.row.OperationType==3?"修改"
                                            : "未知状态"
                            ) },
                    { title: "来源", key: "Source", width: 100, align: 'center' },
                    { title: "说明", key: "Meg", width: 300, align: 'center' },
                    { title: "修改前", key: "OldValue", width: 100, align: 'center' },
                    { title: "修改后", key: "NewValue", width: 100, align: 'center' },
                    { title: "操作人", key: "OperatorUsername", width: 100, align: 'center' }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '来源', type: 'Input', value: '', name: 'Source', sql: 'like' }, 
                    { label: '客户编号', type: 'Input', value: '', name: 'u.userName', sql: 'like' },
                    { label: '客户姓名', type: 'Input', value: '', name: 'u.userPersonName', sql: 'like' },
                    { label: '客户电话', type: 'Input', value: '', name: 'uec.userExternalCustomerPhone', sql: 'like' },
                    { label: '操作人', type: 'Input', value: '', name: 'OperatorUsername', sql: 'like' },
                    { label: '说明', type: 'Input', value: '', name: 'Meg', sql: 'like' },
                    { label: '操作日期', type: 'Daterange', value: '', name: 'CreateTime', sql: 'dateBetween' }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getLogs();
    },
    activated() {
        this.getLogs();
    },
    methods: {
        getLogs() {
            this.loading = true;
            search.globalAddFilterConditionKey(this.mainTable.tableSearch, "ol.Source", "eq", "外部客户账户列表");
            getLogList(this.mainTable.tableSearch)
                .then((res) => {
                    this.loading = false;
                    if (res.code === 0) {
                        if (res.code === 0) {
                            this.mainTable.data = res.data.records;
                            search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                        }
                        this.mainTable.loading = false;
                    }
                });
        },
        onExport(){
            this.loading = true;
            this.mainTable.tableSearch.excelExport.enable = true;
            search.globalAddFilterConditionKey(this.mainTable.tableSearch, "ol.Source", "eq", "外部客户账户列表");
            getLogList(this.mainTable.tableSearch)
                .then((res) => {
                    this.loading = false;
                    if (res.code === 0) {
                        let url = DOWNLOAD_SERVER + res.data.exportFileName;
                        this.$downLoadFile(url);
                        // window.open(FILE_SERVER + res.data.exportFileName, "_blank");
                    }
                });
        }
    }
};
</script>

<style scoped>

</style>